import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { useI18n } from '../i18n/I18nContext';
import { getLocalizedPath } from '../i18n/localizedRoutes';
import { getZiruiProfileSchemas, ziruiProfile } from './ziruiProfileData';
import '../components/ZiruiSpotlight.css';
import './ZiruiProfile.css';

const capabilities = [
  { key: 'commerce', path: '/store' },
  { key: 'design', path: '/custom-design' },
  { key: 'community', path: '/community/scoring' },
];

const ZiruiProfile = () => {
  const { t, locale } = useI18n();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const siteUrl = (process.env.REACT_APP_SITE_URL || (typeof window !== 'undefined' ? window.location.origin : 'https://ych-yoyo.com')).replace(/\/$/, '');

  return (
    <main className="zirui-profile">
      <Seo
        title={t('profile.seoTitle')}
        description={t('profile.seoDescription')}
        path={ziruiProfile.path}
        image={encodeURI(ziruiProfile.image)}
        type="profile"
        structuredData={getZiruiProfileSchemas(t, locale, siteUrl)}
      />
      <div className="zirui-profile-shell">
        <Link className="zirui-profile-back" to={getLocalizedPath('/team', locale)}>← {t('profile.backToTeam')}</Link>
        <header className="zirui-profile-hero">
          <div>
            <p className="zirui-eyebrow">{t('profile.eyebrow')}</p>
            <h1>{t('profile.name')}</h1>
            <p className="zirui-role">{t('profile.role')}</p>
            <p className="zirui-profile-intro">{t('profile.intro')}</p>
            <div className="zirui-actions">
              <a className="zirui-button" href={ziruiProfile.website} target="_blank" rel="noopener noreferrer" data-analytics-target="profile_zirui_website">
                {t('profile.visitWebsite')} <span aria-hidden="true">↗</span>
              </a>
              <a className="zirui-text-link" href={ziruiProfile.website} target="_blank" rel="noopener noreferrer">ziruiqiu.com</a>
            </div>
          </div>
          <img className="zirui-profile-portrait" src={ziruiProfile.image} alt={t('profile.imageAlt')} width="1000" height="1000" decoding="async" />
        </header>

        <section className="zirui-profile-section" aria-labelledby="zirui-platform-title">
          <h2 id="zirui-platform-title">{t('profile.platform.title')}</h2>
          <p>{t('profile.platform.body')}</p>
          <div className="zirui-capabilities">
            {capabilities.map(({ key, path }) => (
              <article key={key}>
                <h3><Link to={getLocalizedPath(path, locale)}>{t(`profile.platform.${key}.title`)} <span aria-hidden="true">→</span></Link></h3>
                <p>{t(`profile.platform.${key}.body`)}</p>
              </article>
            ))}
          </div>
        </section>

        <div className="zirui-profile-columns">
          <section className="zirui-profile-section" aria-labelledby="zirui-yoyo-title">
            <h2 id="zirui-yoyo-title">{t('profile.yoyo.title')}</h2>
            <p>{t('profile.yoyo.body')}</p>
            <ul>
              <li>{t('profile.yoyo.twoA')}</li>
              <li>{t('profile.yoyo.regional')}</li>
              <li>{t('profile.yoyo.national')}</li>
            </ul>
            <Link className="zirui-text-link" to={getLocalizedPath(ziruiProfile.destinyPath, locale)}>{t('profile.yoyo.destinyLink')} <span aria-hidden="true">→</span></Link>
          </section>
          <section className="zirui-profile-section" aria-labelledby="zirui-beyond-title">
            <h2 id="zirui-beyond-title">{t('profile.beyond.title')}</h2>
            <p>{t('profile.beyond.body')}</p>
            <a className="zirui-text-link" href={ziruiProfile.website} target="_blank" rel="noopener noreferrer">{t('profile.websiteLabel')} <span aria-hidden="true">↗</span></a>
          </section>
        </div>

        <section className="zirui-profile-links" aria-labelledby="zirui-links-title">
          <div>
            <h2 id="zirui-links-title">{t('profile.links.title')}</h2>
            <p>{t('profile.links.body')}</p>
          </div>
          <div>
            <a className="zirui-button" href={ziruiProfile.website} target="_blank" rel="noopener noreferrer">{t('profile.visitWebsite')} <span aria-hidden="true">↗</span></a>
            <ul className="zirui-socials">
              {ziruiProfile.socials.map(({ name, url }) => (
                <li key={name}><a href={url} target="_blank" rel="noopener noreferrer">{name} <span aria-hidden="true">↗</span></a></li>
              ))}
            </ul>
          </div>
        </section>
      </div>
    </main>
  );
};

export default ZiruiProfile;
